import React, { Component } from 'react'

class PressRecognition extends Component {
    constructor(props) {
        super(props);
        this.sectionRef = React.createRef();
        this.state = { visible: false };
    }

    componentDidMount() {
        var self = this;
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                function(entries) {
                    if (entries[0].isIntersecting) {
                        self.setState({ visible: true });
                        self.observer.disconnect();
                    }
                },
                { threshold: 0.15 }
            );
            if (this.sectionRef.current) {
                this.observer.observe(this.sectionRef.current);
            }
        } else {
            this.setState({ visible: true });
        }
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    render() {
        var cls = "press_recognition" + (this.state.visible ? " press_visible" : "");

        return (
            <section className={cls} ref={this.sectionRef}>
                <div className="press_recognition_inner">
                    {/* Harper's Bazaar hero endorsement */}
                    <div className="press_hero_quote">
                        <span className="press_hero_kicker">媒體推薦</span>
                        <a href="https://www.harpersbazaar.com/tw/culture/lifestyle/g33736272/taipei-douhua/" target="_blank" rel="noopener noreferrer" className="press_hero_name_link"><h2 className="press_hero_name">Harper's BAZAAR</h2></a>
                        <div className="press_hero_divider"></div>
                        <blockquote className="press_hero_text">
                            入選 Harper's Bazaar 哈潑時尚<br />
                            <span className="press_hero_highlight">「台北豆花6家必吃名單」</span>
                        </blockquote>
                    </div>

                    {/* Supporting press logos */}
                    <div className="press_logos_row">
                        <span className="press_logos_label">同時獲得各大媒體報導</span>
                        <div className="press_logos_list">
                            <span className="press_logo_item">Marie Claire</span>
                            <span className="press_logo_divider"></span>
                            <span className="press_logo_item">中時新聞</span>
                            <span className="press_logo_divider"></span>
                            <span className="press_logo_item">上報 UP Media</span>
                            <span className="press_logo_divider"></span>
                            <span className="press_logo_item">WalkerLand</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PressRecognition;
